/**
 * WHAT: Gallery Page Initialization Module
 * WHY: Handle gallery page specific functionality
 * HOW: JavaScript module with proper imports and exports
 * IMPORTANCE: Separates concerns and follows industry standards
 */

// Import gallery specific functionality
import './gallery.js';

// Initialize gallery page
function initializeGalleryPage() {
    // Any gallery page specific initialization can go here
    console.log('Gallery page initialized');
    
    // Full-page backgrounds: background-rotator.js (same as menu); gallery.js loads grid content only
    // No need for duplicate background image handling here
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeGalleryPage);

// Export for potential use in other modules
export { initializeGalleryPage };
